import defaultPageData from '@/lib/wp/_partials/defaultPageData';
import { gql } from '@apollo/client';

const queryDefaultPageData = gql`
  query GET_DEFAULT_PAGE_DATA {
    ${defaultPageData}
  }
`;

export default queryDefaultPageData;
